import { useEffect, useCallback } from "react"


const TEXT_INPUT_TYPES = [ 'text', 'textarea', 'url', 'tel', 'search', 'password', 'hidden', 'email' ]

const useKeyPress = (targetKey, action) => {
  const handleKeyDown = useCallback(({ key }) => {
    if (key !== targetKey) { return } // only the key in question

    // don't interrupt text inputs
    if(TEXT_INPUT_TYPES.includes(document.activeElement?.type)) { return }

    action()
  }, [targetKey, action]) // Ensure the handler has the latest action and key

  useEffect(() => {
    // Add event listener
    document.addEventListener("keydown", handleKeyDown)

    // Remove event listener on cleanup
    return () => {
      document.removeEventListener("keydown", handleKeyDown)
    }
  }, [handleKeyDown]) // -run the effect if handleKeyDown changes
}

export default useKeyPress
